import { FilterType, Filters } from "@/lib/filters";
import { ColumnSort } from "@tanstack/react-table";
import { formatDate } from "@/lib/utils/formatters";
import { DEFAULT_DATE_FORMAT } from "@/constants";
import { ContractorPanelVisitsFilters } from "../components/ContractorPanelVisitsFilter";
import { DEFAULT_SORT_BY, DEFAULT_SORT_ORDER } from "../constants";
import { ReadContractorVisit } from "@/types/contractorVisit";

export const convertFiltersToBackend = (
  filters: ContractorPanelVisitsFilters,
): Filters<ReadContractorVisit> => {
  const backendFilters: Filters<ReadContractorVisit> = [];
  const isTodayAndUpcoming = filters.isTodayAndUpcoming ?? false;

  if (isTodayAndUpcoming) {
    const todayDate = formatDate(new Date(), DEFAULT_DATE_FORMAT);
    backendFilters.push({
      id: "date",
      value: {
        filter: FilterType.GreaterThanOrEqual,
        value: todayDate,
      },
    });
  }

  if (filters.status) {
    backendFilters.push({
      id: "status",
      value: {
        filter: FilterType.EqualsString,
        value: filters.status,
      },
    });
  }

  if (!isTodayAndUpcoming && filters.date) {
    backendFilters.push({
      id: "date",
      value: {
        filter: FilterType.EqualsString,
        value: filters.date,
      },
    });
  }

  return backendFilters;
};

export const convertSortingToBackend = (
  filters: ContractorPanelVisitsFilters,
): ColumnSort => {
  const sortBy = filters.sortBy || DEFAULT_SORT_BY;
  const sortOrder = filters.sortOrder || DEFAULT_SORT_ORDER;

  return {
    id: sortBy,
    desc: sortOrder === "desc",
  };
};
